import { combineReducers, rm } from 'utils';
import { BaseAction, BaseInitialState, BaseState, baseFormReducer, baseReducer } from '../../Utils';
import {
  BaseZendeskFormAction,
  BaseZendeskFormState,
  Options,
  ZendeskWithProductsInitialState,
  addProductsReducer,
  baseZendeskFormReducer,
  validateProducts,
  validateQuestion,
  validateSubject
} from '../utils';

export const returnAndExchangeFormId = 29744527470482;
export const subjectFieldId = '29545453284242';
const returnFieldId = '29746823066770';
const exchangeFieldId = '29747022842642';

type InternalState = BaseState & BaseZendeskFormState;

export const returnAndExchangeInitialState: InternalState = {
  ...BaseInitialState,
  ...ZendeskWithProductsInitialState,
  showReason: false
};

type Action = BaseAction | BaseZendeskFormAction;

const returnAndExchangeReducer = (state: InternalState, action: Action): InternalState => {
  switch (action.type) {
    case 'showReason':
      return { ...state, showReason: showReason(action.value) };

    default:
      return state;
  }
};

export const reducer = combineReducers<InternalState, Action>(
  baseFormReducer,
  baseReducer,
  returnAndExchangeReducer,
  baseZendeskFormReducer,
  addProductsReducer
);

const showReason = (subject: number) => {
  return subject > 0;
};

type ValidatedState = Omit<InternalState, 'subject' | 'products' | 'reason'> &
  Required<Pick<InternalState, 'subject' | 'products' | 'reason'>>;

export const isValid = (
  state: InternalState,
  dispatch: (action: Action) => void
): state is ValidatedState => {
  const isValidSubject = validateSubject(state, dispatch);
  const isValidQuestion = validateQuestion(state, dispatch);
  const isValidProducts = validateProducts(state, dispatch);

  const isInvalidReason = state.subject && state.reason === undefined;

  if (isInvalidReason) {
    dispatch({
      type: 'reasonError',
      value: rm(
        'customerservice_shared_error_general_part',
        rm('customerservice_zendesk_reason').toLowerCase()
      )
    });
  }

  return isValidSubject && isValidQuestion && isValidProducts && !isInvalidReason;
};

export const getSubjectOptions = (): Options[] => {
  return [
    { id: 1, tag: 'rac_returns' },
    { id: 2, tag: 'rac_exchange' }
  ];
};

export const getReasonOptions = (subject: number): Options[] => {
  if (subject === 1) {
    return getReturnReasonOptions();
  }

  return getExchangeReasonOptions();
};

export const getReturnReasonOptions = (): Options[] => {
  return [
    { id: 1, tag: 'return_no_longer_needed' },
    { id: 2, tag: 'return_ordered_wrong_item' },
    { id: 3, tag: 'return_better_price_available' },
    { id: 4, tag: 'return_did_not_meet_description' },
    { id: 5, tag: 'return_quality_not_as_expected' },
    { id: 6, tag: 'return_delayed_delivery' },
    { id: 7, tag: 'return_other' }
  ];
};

export const getExchangeReasonOptions = (): Options[] => {
  return [
    { id: 1, tag: 'exchange_ordered_wrong_item' },
    { id: 2, tag: 'exchange_did_not_meet_description' },
    { id: 3, tag: 'exchange_quality_not_as_expected' },
    { id: 4, tag: 'exchange_other' }
  ];
};

export const getReasonFieldId = (subject: number) => {
  if (subject === 1) {
    return returnFieldId;
  }
  return exchangeFieldId;
};
